module.exports = __webpack_public_path__ + "static/media/G1-39-Ataque-Simultâneo-das-Amazonas-cod80.c47939bd.png";